module.exports = __webpack_public_path__ + "static/media/star5.7b86a73f.svg";